module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-card', {
    key: _vm.handler,
    staticClass: "ql-page",
    style: (_vm.pageColumnWidth()),
    attrs: {
      "id": "ql-page"
    }
  }, [_c('md-dialog', {
    ref: "no-layers-dialog",
    attrs: {
      "md-open-from": ("cardCover" + _vm.pageNumber),
      "md-close-to": ("cardCover" + _vm.pageNumber)
    }
  }, [_c('md-dialog-title', [_vm._v("You don't have an Active Layer selected!")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("Open up the layers menu and choose a layer to edit.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog('no-layers-dialog')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "no-collaborator-dialog",
    attrs: {
      "md-open-from": ("cardCover" + _vm.pageNumber),
      "md-close-to": ("cardCover" + _vm.pageNumber)
    }
  }, [_c('md-dialog-title', [_vm._v("Observer accounts are unable to add notes and cues.")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog('no-collaborator-dialog')
      }
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "banner-dialog",
    staticClass: "alert-banner-dialog",
    attrs: {
      "md-open-from": ("cardCover" + _vm.pageNumber),
      "md-close-to": ("cardCover" + _vm.pageNumber),
      "md-click-outside-to-close": false,
      "md-esc-to-close": false
    }
  }, [(_vm.editedUser) ? _c('md-dialog-content', {
    staticClass: "alert-content"
  }, [_c('div', {
    staticClass: "alert-box"
  }, [_c('div', {
    staticClass: "alert-icon-box"
  }, [_c('md-icon', {
    staticClass: "alert-icon"
  }, [_vm._v("warning")])], 1), _vm._v(" "), _c('div', {
    staticClass: "alert-text-box"
  }, [_c('h3', {
    staticClass: "alert-title"
  }, [_vm._v("Hold, please!")]), _vm._v(" "), _c('p', {
    staticClass: "alert-message"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(this.editedUser || 'A collaborator'))]), _vm._v(" is currently adding, deleting, or replacing pdf pages in this project. Please wait until the action is completed or canceled.\n                        "), (_vm.project.ownerUID === _vm.user.uid) ? _c('span', {
    staticStyle: {
      "display": "block",
      "margin-top": "8px"
    }
  }, [_vm._v("As the owner, you can take over by clicking the close button below.")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.project.ownerUID === _vm.user.uid) ? _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.closeAlert
    }
  }, [_vm._v("Close anyway")])], 1) : _vm._e()], 1), _vm._v(" "), _c('md-card-media-cover', {
    ref: "cardCover",
    staticClass: "ql-page-cover",
    attrs: {
      "id": ("cardCover" + _vm.pageNumber)
    }
  }, [(_vm.pageReady) ? _c('md-button', {
    staticClass: "btnBookmark md-icon-button",
    style: (_vm.bookmarkStyle),
    on: {
      "click": _vm.togglePageBookmark
    }
  }, [_c('md-icon', [_vm._v(_vm._s(_vm.bookmarked ? 'bookmark' : 'bookmark_border'))]), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.bookmarked ? 'Remove from My Bookmarks' : 'Add to My Bookmarks'))])], 1) : _vm._e(), _vm._v(" "), (_vm.ready) ? _c('project-pdf-page', {
    staticClass: "ql-pdf-page",
    class: {
      'night-mode': _vm.showMode,
      'disable-text': _vm.disableText
    },
    attrs: {
      "page": _vm.page,
      "pageWidth": _vm.pageWidth,
      "pageHeight": _vm.pageHeight,
      "currentCueLayer": _vm.currentCueLayer,
      "locked": _vm.locked,
      "issrc": _vm.issrc,
      "openCues": _vm.openCues,
      "positionedCues": _vm.positionedCues,
      "svgTrueHeight": _vm.svgTrueHeight,
      "selectedElement": _vm.selectedElement
    },
    on: {
      "pdfLoaded": _vm.pdfLoaded,
      "updatePageHistory": _vm.updatePageHistory,
      "cueCreated": _vm.cueCreated,
      "addNote": _vm.addNote,
      "openDialog": _vm.openDialog
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.ready) ? _c('p', [_vm._v("Loading PDF...")]) : _vm._e(), _vm._v(" "), _c('resize-sensor', {
    on: {
      "resize": _vm.resize
    }
  })], 1), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "marker-container",
    class: {
      'marker-container--place-mode': _vm.canPlaceScriptMarker,
      'marker-container--reach-marks': !_vm.cueTakesPress
    },
    style: (_vm.markerContainerStyle()),
    on: {
      "dblclick": _vm.onMarkerContainerPlace,
      "touchstart": _vm.onMarkerContainerTouchStart,
      "touchend": _vm.onMarkerContainerTouchEnd,
      "touchcancel": _vm.onMarkerContainerTouchEnd,
      "touchmove": _vm.onMarkerContainerTouchMove
    }
  }, [_vm._l((_vm.positionCues), function(cue) {
    return _c('cue-position-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": _vm.isCueEditable(cue),
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateCue": _vm.updateCue,
        "activated": function($event) {
          return _vm.onCueActivated(cue)
        },
        "deactivated": function($event) {
          return _vm.onCueDeactivated(cue)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.selectionCues), function(cue) {
    return _c('cue-selection-marker', {
      key: ("" + (cue.id) + _vm.versionID),
      attrs: {
        "cue": cue,
        "editable": _vm.isCueEditable(cue),
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight
      },
      on: {
        "updateCue": _vm.updateCue,
        "activated": function($event) {
          return _vm.onCueActivated(cue)
        },
        "deactivated": function($event) {
          return _vm.onCueDeactivated(cue)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.scriptMarkersOnPage), function(marker) {
    return _c('script-marker-overlay', {
      key: ((marker.markerId || marker.id) + "-" + _vm.pageWidth + "-" + _vm.pageHeight),
      attrs: {
        "marker": marker,
        "editable": _vm.canEditStructure && !_vm.locked,
        "locked": _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight,
        "startInlineEdit": (marker.markerId || marker.id) === _vm.pendingInlineEditMarkerId
      },
      on: {
        "updateMarker": _vm.updateScriptMarker,
        "deleteMarker": _vm.deleteScriptMarker,
        "inlineEditDone": _vm.clearPendingInlineEdit,
        "activated": function($event) {
          _vm.disableText = true
        },
        "deactivated": function($event) {
          _vm.disableText = false
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.drawingsPaintedAbove), function(note) {
    return _c('div', {
      key: ("paint-" + (note.id) + _vm.versionID),
      staticClass: "ql-note-free-drawing ql-drawing-paint-only",
      style: (_vm.drawingPaintStyle(note))
    }, [_c('div', {
      staticClass: "note-free_drawing",
      domProps: {
        "innerHTML": _vm._s(note.text)
      }
    })])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.pageReady) ? _c('div', {
    staticClass: "ql-note-container",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px")
    })
  }, _vm._l((_vm.displayNotes), function(note) {
    return _c('project-note-template', {
      key: ("" + (note.id) + _vm.versionID),
      class: {
        'ql-drawing-hit-only': _vm.isDrawingPaintedAbove(note)
      },
      attrs: {
        "note": note,
        "locked": !_vm.isNoteEditable(note) || _vm.locked,
        "pageWidth": _vm.pageWidth,
        "pageHeight": _vm.pageHeight,
        "totalPages": _vm.totalPages,
        "selectedElement": _vm.selectedElement,
        "currentNoteLayerBackground": _vm.currentNoteLayerBackground
      },
      on: {
        "setSelectedElement": _vm.setSelectedElement,
        "updatePageHistory": _vm.updatePageHistory,
        "copyElement": _vm.copyElement,
        "updateNote": _vm.updateNote,
        "activated": function($event) {
          return _vm.onNoteActivated(note)
        },
        "deactivated": function($event) {
          return _vm.onNoteDeactivated(note)
        }
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.pageReady) ? _c('canvas', {
    staticClass: "ql-drawing-overlay",
    style: ({
      left: (_vm.offsetX + "px"),
      width: (_vm.pdfWidth + "px"),
      height: (_vm.pdfHeight + "px")
    }),
    attrs: {
      "id": ("ql-drawing-overlay-" + _vm.pageNumber)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0639b722","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/page.vue
// module id = 1199
// module chunks = 21